import { pushEvent } from 'src/client/data-layer';

export type TrackInternalNavigationClickData = {
  scope: InternalNavigationScope;
  nextPage: string;
  index?: number;
};

export const trackInternalNavigationClick = (
  data: TrackInternalNavigationClickData
) => {
  pushEvent('internal_navigation_click', {
    scope: data.scope,
    current_page: window.location.pathname + window.location.search,
    next_page: data.nextPage,
    index: typeof data.index === 'number' ? data.index + 1 : 'no index',
  });
};

export enum InternalNavigationScope {
  ABOUT_REVIEWS = 'About reviews',
  ARTICLE_CONTENT_CARD = 'Article - content card',
  ARTICLE_CONTENT_CARD_EXPERT = 'Article - content card expert',
  ARTICLE_READ_MORE = 'Article - read more',
  ARTICLE_SHOW_ALL = 'Article - show all',
  AUTHORIZED_DEALER = 'Authorized dealer',
  BRAND_CARD = 'Brand - card',
  BRAND_CATEGORY_CARD = 'Brand - category card',
  BRAND_CATEGORY_TREE = 'Brand - category tree',
  BRAND_PRODUCT_CARD = 'Brand - product card',
  BREADCRUMB = 'Breadcrumb',
  CAMPAIGN_CARD = 'Campaign - card',
  CAMPAIGN_HEADER = 'Campaign - header',
  CAMPAIGN_PRODUCT_CARD = 'Campaign - product card',
  CAMPAIGN_SHOW_ALL = 'Campaign - show all',
  CATEGORY_CARD = 'Category - card',
  CATEGORY_LIST_SUB_LVL = 'Category list - sub level',
  CATEGORY_LIST_TOP_LVL = 'Category list - top level',
  COMPACT_LIST_LAYOUT_PRODUCT_CARD = 'Compact list layout - product card',
  EXPERT_ADVISE_SHOW_ALL = 'Expert advise - show all',
  EXPERT_ALL_CATEGORIES = 'Expert - all categories',
  EXPERT_CATEGORY = 'Expert - category',
  EXPERT_INDEPENDENT_GUARANTEE = 'Expert - independent guarantee',
  EXPERT_LIST_CARD = 'Expert list - card',
  EXPERT_SHOW_ALL = 'Expert - show all',
  EXPERT_TOP_LIST = 'Expert - top list',
  FALLBACK_RECOMMENDATIONS_PRODUCT_CARD = 'Fallback recommendations - product card',
  FALLBACK_RECOMMENDATIONS_HEADER = 'Fallback recommendations - header',
  FEATURED_CATEGORY_ARTICLE = 'Featured category article',
  FEATURED_PRODUCTS_PRODUCTS_CARD = 'Featured products - product card',
  FEATURED_PRODUCTS_HEADER = 'Featured products - header',
  FOOTER_INFO_PAGES = 'Footer - info pages',
  FORUM_TOPIC = 'FORUM - topic',
  FORUM_GO_TO = 'FORUM - go to',
  GRID_LAYOUT_PRODUCT_CARD = 'Grid layout - product card',
  LIST_LAYOUT_PRODUCT_CARD = 'List layout - product card',
  NAVIGATION_CAROUSEL = 'Navigation carousel',
  NEWSLETTER_EMAIL_PRIVACY = 'Newsletter - email privacy',
  NEW_PRODUCT_RELEASES_PRODUCT_CARD = 'New Product releases - product card',
  NEW_PRODUCT_RELEASES_HEADER = 'New Product releases - header',
  OTHER_VISITED_PRODUCTS_PRODUCT_CARD = 'Other visted - product card',
  PERSONALIZED_RECOMMENDATIONS_PRODUCT_CARD = 'Personalized recommendations - product card',
  PERSONALIZED_RECOMMENDATIONS_HEADER = 'Personalized recommendations - header',
  PRODUCT_INFORMATION = 'Product information',
  POPULAR_FACETS_HEADER = 'Popular facets - header',
  POPULAR_FACETS_PRODUCT_CARD = 'Popular facets - product card',
  POPULAR_PRODUCTS_SHOW_ALL = 'Popular products - show all',
  POPULAR_PRODUCTS_PRODUCT_CARD = 'Popular products - product card',
  RECENTLY_VISITED_PRODUCTS_PRODUCT_CARD = 'Recently visited - product card',
  REVIEW_READ_ALL = 'Review - read all',
  REVIEW_USER_CARD = 'Review - user card',
  STORE_AWARD_CARD = 'Store - award card',
  STORE_CARD = 'Store - card',
  STORE_REVIEW = 'Store - review',
  STORE_GO_TO = 'Store - go to store',
  RELATED_SEARCHES_SHOW_MORE = 'Related searches - show more',
  RELATED_SEARCHES_WORD = 'Related searches - word',
  SECONDARY_NAVIGATION = 'Secondary navigation',
  TABLE_LAYOUT_PRODUCT_CARD = 'Table layout - product card',
  TRENDING_PRODUCTS_PRODUCT_CARD = 'Trending products - product card',
  TRENDING_PRODUCTS_HEADER = 'Trending products - header',
}
